import { Box, styled } from '@mui/material';

export const StyleSimpleBorderContainer = styled(Box, {
  shouldForwardProp: (prop: string) =>
    !['isShowBorder', 'isShowBackground', 'isShowPadding', 'paddingLeft', 'customPaddingContainer'].includes(
      prop,
    ),
})<{
  isShowBorder?: boolean;
  isShowBackground?: boolean;
  isShowPadding: boolean;
  paddingLeft?: string;
  customPaddingContainer?: string;
}>(({ theme, isShowBorder, isShowBackground, isShowPadding, paddingLeft, customPaddingContainer }) => ({
  width: '100%',
  borderRadius: '8px',
  position: 'relative',
  padding: isShowPadding ? customPaddingContainer || '16px' : 0,
  paddingLeft: paddingLeft ? paddingLeft : isShowPadding ? '16px' : 0,
  backgroundColor: isShowBackground ? theme.palette.case.neutral.n0 : 'transparent',
  border: isShowBorder ? `1px solid ${theme.palette.case.neutral.n200}` : 'none',
  [theme.breakpoints.down('sm')]: {
    padding: isShowPadding ? customPaddingContainer || '12px' : 0,
  },
}));
